import { Button } from '@jouzen/ecom-components/v3/Button';
import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useTranslations } from 'next-intl';

import { EventType } from '@/analytics/types';

interface NewsroomAccordionContentProps {
  readonly subcopy: string | undefined;
  readonly url: string | undefined;
}

export const NewsroomAccordionContent = ({
  subcopy,
  url,
}: NewsroomAccordionContentProps) => {
  const t = useTranslations();
  const handleReadMoreClick = async (): Promise<void> => {
    await window.ouraAnalytics.track(EventType.LinkClicked, {
      cta: 'Read More',
      location: 'Newsroom Page',
      path: url,
      action: 'go to article',
    });
  };
  return (
    <>
      <Typography className="mt-0 mb-5" data-cy="newsroom-subcopy">
        {subcopy ?? ''}
      </Typography>
      <Button
        data-cy="newsroom-read-more"
        href={url ?? ''}
        variant="secondary-dark"
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleReadMoreClick}
      >
        {t('read_more')}
      </Button>
    </>
  );
};
